import { networker } from "../http";

const cacheStore = new Map();

async function cachedGet(url, { ttl = 5 * 60 * 1000, force = false } = {}) {
    const now = Date.now();

    if (!force && cacheStore.has(url)) {
        const { data, timestamp, promise } = cacheStore.get(url);

        // Если есть активный промис → ждём его
        if (promise) return promise;

        // Проверка TTL
        if (now - timestamp < ttl) {
            return data; // вернуть из кэша
        }
    }

    // Создаём новый запрос и сохраняем промис
    const requestPromise = networker.get(url).then(res => {
        cacheStore.set(url, {
            data: res,
            timestamp: Date.now(),
            promise: null // запрос завершён
        });
        return res;
    });

    cacheStore.set(url, { data: null, timestamp: now, promise: requestPromise });

    return requestPromise;
}

export { cachedGet };